import { useI18n } from 'next-localization';
import PerformanceTableBase from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/PerformanceTableBase';
import { endpoints } from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/performanceEndpoints';

type Props = {
  classname?: string;
};

const AnnualizedDailyTable = ({ className }: Props) => {
  const { t } = useI18n();
  return (
    <PerformanceTableBase
      title={t('fundDetailsAnnualizedDailyPerformanceTitle')}
      footnoteText={t('fundDetailsPerformanceAnnualizedFootnote')}
      wrapperId="annualizedDailyWrapper"
      tableId="annualizedDailyTable"
      endpoint={endpoints.ANNUALIZED_DAILY}
      className={className}
    />
  );
};

export default AnnualizedDailyTable;
